import React, { useEffect, useState } from "react";
import { useUserStore } from "../../../store/userStore.js";
import { useLocation } from "react-router-dom";
import { Empty } from "antd";


import UserProfileLayout from "../../../components/layout/userprofilelayout/userprofilelayout";
import UserProfilePhotoBox from "../../../components/userprofilephptos/userprofilephotobox";
import Loader from "../../../components/loader/loader";

export default function PhotosPending() {
  const location = useLocation();
  const { user: userData, isUserLoading: userLoading, getUser, updateUser } =
    useUserStore();

  const username = location.pathname.split("/")[2];

  const [galleryData, setGalleryData] = useState();

  useEffect(() => {
    setGalleryData(userData?.imageGallery);
  }, [userData]);

  useEffect(() => {
    getprofileData();
  }, [username]);

  const getprofileData = () => {
    const payload = { username };
    getUser(payload);
  };

  const updateProfile = (newGalleryData, status, reason) => {
    const updatedGalleryData = newGalleryData?.map(
      ({ signedUrl, ...rest }) => rest
    );

    const payload = {
      username,
      data: { imageGallery: updatedGalleryData },
      notification: {
        route: "/gallery",
        reason: reason ?? null,
        event:
          status === "approved" ? "photoApprovedAdmin" : "photoRejectedAdmin",
      },
    };
    updateUser(payload, () => getprofileData());
  };

  return (
    <UserProfileLayout>
      {userLoading ? (
        <Loader />
      ) : (
        <div className="bg-white rounded-2xl border border-primary50 w-full">
          {userData?.imageGallery && userData?.imageGallery?.length > 0 ? (
            <div className="grid grid-cols-4 p-8 gap-5">
              {userData?.imageGallery?.map(
                (item, index) =>
                  item?.status === "pending" && (
                    <UserProfilePhotoBox
                      galleryData={galleryData}
                      updateProfile={updateProfile}
                      key={index}
                      userimg={item?.signedUrl}
                      userimgoriginal={item?.originalUrl}
                      status={item?.status}
                    />
                  )
              )}
            </div>
          ) : (
            <Empty />
          )}
        </div>
      )}
    </UserProfileLayout>
  );
}








